import { css } from 'lit';
import { hostReset, floatingPanel, placementOriginsExtended } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  floatingPanel('.panel', { durationVar: '--uwc-overlay-duration', durationDefault: '160ms' }),
  placementOriginsExtended,
  css`
    :host { display: contents; }
    slot[name="trigger"] { display: contents; }

    /* ── Backdrop ───────────────────────────────────────────────────────────── */
    .backdrop {
      position: fixed;
      inset: 0;
      margin: 0;
      border: none;
      background: var(--uwc-backdrop-color, rgba(0,0,0,0.25));
      z-index: calc(var(--uwc-overlay-z, ${t.zFloat}) - 1);
      opacity: 0;
      transition:
        opacity  var(--uwc-overlay-duration, 160ms) ease,
        display  var(--uwc-overlay-duration, 160ms) allow-discrete,
        overlay  var(--uwc-overlay-duration, 160ms) allow-discrete;
    }
    .backdrop.is-open,
    .backdrop:popover-open { opacity: 1; }

    /* ── Panel (visual) ─────────────────────────────────────────────────────── */
    .panel {
      padding:       0;
      background:    var(--uwc-overlay-bg,     ${t.surface});
      border:        var(--uwc-overlay-border, 1px solid ${t.border});
      border-radius: var(--uwc-overlay-radius, ${t.radiusLg});
      box-shadow:    var(--uwc-overlay-shadow, ${t.shadowLg});
      min-width:     160px;
      z-index:       var(--uwc-overlay-z, ${t.zFloat});
    }
  `,
];
